import { render, staticRenderFns } from "./NavigateToActionableReportLink.vue?vue&type=template&id=b5595d44&"
import script from "./NavigateToActionableReportLink.vue?vue&type=script&lang=js&"
export * from "./NavigateToActionableReportLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5595d44')) {
      api.createRecord('b5595d44', component.options)
    } else {
      api.reload('b5595d44', component.options)
    }
    module.hot.accept("./NavigateToActionableReportLink.vue?vue&type=template&id=b5595d44&", function () {
      api.rerender('b5595d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/NavigateToActionableReportLink.vue"
export default component.exports